<template>
  <div class="pagation">
    <div class="pages">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        prev-text="上一页"
        next-text="下一页"
        :page-sizes="[15, 30, 45]"
        layout="slot,prev, pager, next"
        :total="total">
        <el-button :disabled="firstDisabled" @click="toFirstPage" type="text" style="margin-right:30px;" size="mini">
          首页
        </el-button>
      </el-pagination>
      <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        prev-text="上一页"
        next-text="下一页"
        :page-sizes="[27, 15, 30, 45]"
        layout="slot"
        :total="total">
        <el-button :disabled="isLastDisabled" @click="toLastPage" style="margin-left:30px;">尾页</el-button>
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: "pages",
  components: {},
  data() {
    return {
      pageSize: 27,
      totalPage: Math.ceil(this.total / this.pageSize),
      currentPage: 1,
      firstDisabled: true,
      page:0,
    }
  },
  props:['total','pages'],
  watch: {
    totalPage(val) {
      this.total = val;
      this.totalPage = Math.ceil(val / this.pageSize);
    }
  },

  computed: {
    isLastDisabled() {
      if (this.totalPage <= 0) {
        return true;
      }
      return this.currentPage == this.totalPage ? true : false;
    }
  },
  created() {
    this.currentPage = Math.ceil(this.total / this.pageSize);
  },

  beforeUpdate(){
    this.page = Math.ceil(this.total / this.pageSize);
  },

  methods: {
    toFirstPage() {
      this.handleCurrentChange(1);
    },
    toLastPage() {
      this.handleCurrentChange(this.page);
    },
    handleCurrentChange(val) {
      this.firstDisabled = val == 1 ? true : false;
      this.currentPage = val;

      this.$emit("handleCurrentChangeSub", this.pageSize, val);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.$emit("handleCurrentChangeSub", val, this.currentPage);
    }
  }
};
</script>
<style>
.pagation {
  width: 100%;
  height: 32px;
  padding: 10px 0px;
  text-align: center;
}

.pages {
  overflow: hidden;
}

.el-pagination {
  display: inline-block;
}

.el-pagination.is-background .el-pager li {
  background: none;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 50%;
  background-color: #0F2B06;
}

.el-pager {
  margin: 0 30px;
}

.el-pager.number {
  background-color: transparent;
}

.btn-prev, .btn-next {
  background-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/components/PagesOther.vue